// This was taken from Galaxy's FP integration; we may need to tweak as needed
export const parameters = {
  // ButtonType: 5,
  Button: {
    Integrated: false,
  },
  CardNumber: {PlaceholderType: 3},
  ExpirationDate: {PlaceholderType: 2},
  SecurityCode: {PlaceholderType: 3},
  PostalCode: {PlaceholderType: 3},
  Styles: `
    form {
      padding: 0;
    }
    button{
      background-color: #A41B32;
      border: none;
      border-radius: 16px;
      font-size: 14px;
      font-weight: 600;
      height: 36px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
    button:hover{
      background-color: #9B1B20;
      border: none;
    }
    button:disabled{
      opacity: 0.4;
    }
    input{
      border: 1px solid #BEC0C5;
      border-radius: 4px;
      color: #707784;
      font-family: Open Sans;
      font-size: 16px;
      letter-spacing: 0.79px;
      height: 44px;
    }
    input:focus{
      border-color:  #141414;
      border-radius: 4px 4px 0 0;
      box-shadow: 0px 2px 0px 0px #000;
    }
    .valid input{
      border-color: #343840;
      border-radius: 4px;
    }
    .invalid input{
      border: 2px solid #D60000;
      border-radius: 4px;
      color: #D60000;
      font-weight: 600;
      margin-bottom: 0px;
    }
    input::placeholder{
      color: #707378;
      font-weight: 500;
    }
    label{
      color: #343840;
      text-transform: uppercase;
      font-size: 11px;
      line-height: 10px;
      font-family: Open Sans;
      font-weight: 700;
      letter-spacing: 0.79px;
    }
    `,
};
